export default "__VITE_ASSET__DvHt0IAw__"